import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config/api';
import { useAuth } from '../contexts/AuthContext';

// Pages légales visibles si : interrupteur admin ON, ou environnement preview, ou admin connecté.
export const useLegalVisible = () => {
  const { user } = useAuth();
  const [state, setState] = useState({ visible: false, published: false, env: 'production', loaded: false });

  useEffect(() => {
    let active = true;
    axios.get(`${API}/legal/visibility`, { withCredentials: true })
      .then(r => active && setState({ ...r.data, loaded: true }))
      .catch(() => active && setState(s => ({ ...s, loaded: true })));
    return () => { active = false; };
  }, [user]);

  return state;
};
